import { initFederation } from '@angular-architects/native-federation';

initFederation()
    .catch((err) => console.warn('[Federation] Init failed, continuing without MFE support:', err))
    .then(() => import('./bootstrap'))
    .catch((err) => console.error(err));
